import { render, staticRenderFns } from "./whatsapp-panel.vue?vue&type=template&id=f9d2267a"
import script from "./whatsapp-panel.vue?vue&type=script&lang=ts"
export * from "./whatsapp-panel.vue?vue&type=script&lang=ts"
import style0 from "./whatsapp-panel.vue?vue&type=style&index=0&id=f9d2267a&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/volateq-web-app/volateq-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9d2267a')) {
      api.createRecord('f9d2267a', component.options)
    } else {
      api.reload('f9d2267a', component.options)
    }
    module.hot.accept("./whatsapp-panel.vue?vue&type=template&id=f9d2267a", function () {
      api.rerender('f9d2267a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/analysis/edit-analysis/edit-analysis-admin/whatsapp-panel.vue"
export default component.exports